import { useEffect } from 'react';

import { useOutsideClick } from '@travel/traveler-core/hooks';

function useOutsideClickWithEscape(
  dropDownRef: React.RefObject<HTMLDivElement | null>,
  inputRef: React.RefObject<HTMLInputElement | null>,
  fn: () => void,
) {
  // Reusing outside click detection
  useOutsideClick(dropDownRef, inputRef, fn);

  // Extending the functionalities of useOutsideClick
  // Add escape key detection- handles Esc keyboard button click
  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        fn();
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [fn]);
}

export default useOutsideClickWithEscape;
